<template>
  <div id="app" ref="app">
      <Share ref="shareRef"></Share>
     <Loading v-if="$store.state.loading"></Loading>
    <header id="nav">
        <div class="logo" @click="toIndex" title="返回主页">
          <h1><img src="https://qiniu.swarma.org/business/jpg/global/logo.png" alt="集智学园-企业培训"></h1>
        </div>
        <!-- pc -->
        <div class="right mobileNone">
          <router-link to="/">首页</router-link>
          <router-link to="/training">企业培训</router-link>
          <router-link to="/case">合作案例</router-link>
          <router-link to="/teacher">讲师介绍</router-link>
          <router-link to="/advisory">企业咨询</router-link>
          <a target="_blank" rel="noopener" href="https://campus.swarma.org">集智学园</a>
          <a target="_blank" rel="noopener" href="https://pattern.swarma.org">集智斑图</a>
        </div>
        <!-- 移动和平板 -->
        <div class="mobileNav pcnone">
          <div @click="opennav = !opennav">导航</div>
          <ul v-if="opennav">
            <router-link to="/">首页</router-link>
            <router-link to="/training">企业培训</router-link>
            <router-link to="/case">合作案例</router-link>
            <router-link to="/teacher">讲师介绍</router-link>
            <router-link to="/advisory">企业咨询</router-link>
            <a target="_blank" rel="noopener" to="https://campus.swarma.org">集智学园</a>
            <a target="_blank" rel="noopener" to="https://pattern.swarma.org">集智斑图</a>
          </ul>
        </div>
    </header>
    <!-- 内容 -->
    <router-view/>
    <footer id="footer">
      <h3 class="title">合作咨询</h3>
      <div class="footer-content">
        <div class="footer-content-form">
          <textarea class="form-item form-textarea" v-model="content" placeholder="请描述您的需求" name="" id="" cols="30" rows="10"></textarea>
          <input class="form-item input-item" v-model="name" type="text" placeholder="姓名">
          <input class="form-item input-item" v-model="email" type="email" placeholder="邮箱">
          <input class="form-item input-item" v-model="phone" type="text" placeholder="电话">
          <button class="form-item input-item submitbtn" @click="submitCommond">提交</button>
        </div>
        <div class="footer-content-code mobileNone">
          <div class="img">
            <img  src="https://qiniu.swarma.org/business/jpg/global/weixin.jpg" alt="集智学园">
            <div>集智小助手</div>
          </div>
          <div class="img">
            <img  src="https://qiniu.swarma.org/business/jpg/global/gongzhonghao.jpg" alt="集智学园">
            <div>学园公众号</div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import Utils from '@/api/utils.js'
import Loading from '@/components/loading'
import Share from '@/components/share'
export default {
  components: {
    Loading,
    Share
  },
  data () {
    return {
      opennav: false,
      name: '',
      content: '',
      phone: '',
      email: ''
    }
  },
  watch: {
    $route (to, from) {
      this.opennav = false
      // 全局路由的监听
      if (to.path === '/swarma') {
        window.open('https://campus.swarma.org')
        this.opennav = false
        this.$router.push({
          name: from.name
        })
      } else {
        scrollTo(0, 0)
        if (to.name !== from.name) {
          this.baidu()
          this.$nextTick(() => {
            this.$refs['shareRef'].shareConfig();
          })
        }
      }
    }
  },
  mounted () {
    // wx && wx.ready(() => {
    //   this.weChatShare();
    // });
  },
  methods: {
    baidu () {
      console.log(1)
        var _hmt = _hmt || [];
        // (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?01ceba6ebe0845cd7827e6624ea9e597";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
        // })();
    },
    toIndex () {
      this.$router.push({
        name: 'home'
      })
    },
    submitCommond () {
      let data = {
        content: this.content,
        email: this.email,
        phone: this.phone,
        name: this.name
      }
      let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      if (!data.content) {
        this.$message.info('忘记填内容啦～')
        return
      } else if (data.email) {
        if (!pattern.test(data.email)) {
          this.$message.info('请输入合法的邮箱')
          return
        }
      }
      this.$store.commit('setLoading', true)
      Utils.submitCommond(data).then(res => {
        this.$store.commit('setLoading', false)
        if (res.code === '1') {
          this.$message.success('提交成功, 我们会尽快和您联系')
          this.email = ''
          this.content = ''
          this.name = ''
          this.phone = ''
        } else {
          this.$message.info(res.data)
        }
      })
    },
  }
}
</script>

<style lang="less">
* {
  margin: 0;
}
body,
#app {
  overflow-x: hidden;
}
#nav {
  color: #fff;
  height: 60px;
  line-height: 60px;
  background: #25262b;
  padding: 0 10%;
  z-index: 1999;
  // position: relative;
  font-size: 14px;
  h1 {
    height: 60px;
    font-size: 16px;
  }
  .logo {
    cursor: pointer;
    position: absolute;
    img {
      position: absolute;
      top: 50%;
      transform: translatey(-50%);
      height: 70%;
      left: -85%;
    }
  }
  .right {
    text-align: right;
    a {
      display: inline-block;
      margin: 0 20px;
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;
      color: #e4e4e4;
      &.router-link-exact-active.router-link-active {
        color: #e0841b;
      }
    }
  }
}
#footer {
  background: #25262b;
  padding: 3% 10%;
  h3 {
    color: #fff;
    margin: 10px 0;
    font-size: 16px;
  }
  .footer-content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    .footer-content-form {
      width: 70%;
      margin-right: 20px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .form-item {
        border: none;
        background: #474951;
        box-sizing: border-box;
        color: #fff;;
      }
      textarea {
        padding: 10px;
        width: 100%;
        height: 100px;
        margin: 10px 0;
      }
      .input-item {
        width: 23%;
        height: 34px;
        padding: 0 10px;
        box-sizing: border-box;
        margin: 10px 0;
      }
      button.input-item {
        background: #f80;
        color: #fff;
        height: 34px;
        padding: 1px 20px;
        cursor: pointer;
        &:hover {
          background: #e0841b;
        }
      }
    }
    .footer-content-code {
      width: calc(30% - 20px);
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .img {
        width: 50%;
        text-align: center;
        color: #fff;
        img {
          display: inline-block;
          width: 80%;
          margin: 0 5%;
        }
      }
    }
  }
}
.banner img {
  width: 100%;
  display: inherit;
}
h1.title {
  text-align: center;
  color: #333;
  height: 60px;
  font-size: 38px;
  margin-bottom: 20px;
  font-weight: normal;
  width: 100%;
}
// pc
@media screen and(min-width: 769.5px){
  .pcnone {
    display: none;
  }
}
// 平板
@media screen and(max-width: 769px) {
  .mobileNone {
    display: none;
  }
  #footer .footer-content .footer-content-code.mobileNone {
    display: none;
  }
  h1.title {
    font-size: 18px;
    height: inherit;
  }
  #footer {
    .footer-content {
      .footer-content-form {
        width: 100%;
      }
    }
  }
  .mobileNav {
    text-align: right;
    ul {
      position: absolute;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      text-align: center;
      right: 20px;
      z-index: 999;
      background: #33333396;
      padding: 0 20px;
      a {
        font-size: 14px;
        // cursor: pointer;
        text-decoration: none;
        color: #e4e4e4;
        &.router-link-exact-active.router-link-active {
          color: #e0841b;
        }
      }
    }
  }
}
// 手机端
@media screen and(max-width: 414px) {
  #footer {
    .footer-content {
      .footer-content-form {
        .input-item {
          width: 100%;
        }
      }
    }
  }
}
</style>
